import config from 'config';

export default {
  title: 'Book great loads from North America’s top brokers',
  content: `Included for free with your ${config.partner.partnerName} ELD subscription`,
};
